
;
                (function(){
                    const Func = (function() {
                        let e=this.$el.querySelector(".ecom-shopify__article__description-view-more-btn"),l=this.settings.content_type,s=this.$el.querySelector(".ecom-shopify__article__description--full"),r=this.$el.querySelector(".ecom-shopify__article__description--paragraph");e&&e.addEventListener("click",function(){l==="text"&&s?(s.style.display="inherit",r.style.display="none"):r.style.maxHeight=null,this.style.display="none"})
                    
                    });
                    const settings = {"content_type":"html"};
                    const ID = 'ecom-5ain4at3t56';
                    document.querySelectorAll('.ecom-5ain4at3t56').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.layout==="slider"){let t=this.$el;if(!t)return;let i=t.querySelector(".ecom-shopify__blog-container"),o=i&&i.dataset.optionSwiper;o=JSON.parse(o),o.pagination={el:t.querySelector(".ecom-swiper-pagination"),type:"bullets",clickable:!0},o.navigation={nextEl:t.querySelector(".ecom-swiper-button-next"),prevEl:t.querySelector(".ecom-swiper-button-prev")},new window.EComSwiper(i,o)}
                    
                    });
                    const settings = {"layout":"grid"};
                    const ID = 'ecom-vmk0saygd3';
                    document.querySelectorAll('.ecom-vmk0saygd3').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            